import MuiPhoneNumberField from 'components/FormField/MuiPhoneNumberField'

import MuiEmailField from 'components/FormField/MuiEmailField'
import MuiTextField from 'components/FormField/MuiTextField'
import IntegerField from 'components/FormField/IntegerField'
import MuiIntegerField from 'components/FormField/MuiIntegerField'
import MuiMultiSelect from 'components/FormField/MuiMultiSelect'
import MuiSelectField from 'components/FormField/MuiSelectField'
import { MuiDateField } from 'components/FormField/MuiDateField'
import MuiZipcodeField from 'components/FormField/MuiZipcodeField'
import MuiCurrencyFloatField from 'components/FormField/MuiCurrencyFloatField'
import MuiFloatField from 'components/FormField/MuiFloatField'
import { DeductionsStep } from 'components/FormField/DeductionsStep'
import { DeductionTypeSelection } from 'components/FormField/DeductionsStep/DeductionTypeSelection'
import { TspLoansStep } from 'components/FormField/TspLoansStep'
import { TspLoanReview } from 'components/FormField/TspLoanReview'
import MuiPercentageField from 'components/FormField/MuiPercentageField'
import { DeductionsStepReview } from 'components/FormField/DeductionsStep/DeductionsStepReview'

import { MuiSplitDateField } from 'components/FormField/MuiSplitDateField'

export const renderMuiFormField = ({
  inputType,
  label,
  placeholder,
  required = false,
  value,
  onChange,
  onBlur = () => {},
  options,
  showAdornment = false,
  handleFieldFocus,
  forceError,
  id,
  disabled = false,
  enableHelpText,
  helpText,
  fullWidth = true,
  shrink,
  optionMatchValue,
  optionMatchProp,
  searchable = false,
  ...rest
}) => {
  switch (inputType) {
    case 'text':
      return (
        <MuiTextField
          showAdornment={showAdornment}
          id={id}
          enableHelpText={enableHelpText}
          helpText={helpText}
          fullWidth={fullWidth}
          label={label}
          placeholder={placeholder}
          required={required}
          type={inputType}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          // trim the value of the field
          onBlur={(e) => onBlur(e.target.value.trim())}
          disabled={disabled}
          {...rest}
        />
      )

    case 'int':
      return (
        <MuiIntegerField
          showAdornment={showAdornment}
          id={id}
          enableHelpText={enableHelpText}
          helpText={helpText}
          fullWidth={fullWidth}
          label={label}
          placeholder={placeholder}
          required={required}
          type={inputType}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur(e.target.value)}
          disabled={disabled}
          {...rest}
        />
      )

    case 'currencyFloat':
      return (
        <MuiFloatField
          isCurrency
          showAdornment={showAdornment}
          id={id}
          enableHelpText={enableHelpText}
          helpText={helpText}
          fullWidth={fullWidth}
          label={label}
          placeholder={placeholder}
          required={required}
          type={inputType}
          value={value || ''}
          onChange={onChange}
          shrink={shrink}
          onBlur={onBlur}
          disabled={disabled}
          {...rest}
        />
      )

    case 'floatField':
      return (
        <MuiFloatField
          isCurrency={false}
          showAdornment={showAdornment}
          id={id}
          enableHelpText={enableHelpText}
          helpText={helpText}
          fullWidth={fullWidth}
          label={label}
          placeholder={placeholder}
          required={required}
          type={inputType}
          value={value || ''}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          {...rest}
        />
      )

    case 'percentage':
      return (
        <MuiPercentageField
          showAdornment={showAdornment}
          id={id}
          enableHelpText={enableHelpText}
          helpText={helpText}
          fullWidth={fullWidth}
          label={label}
          placeholder={placeholder}
          required={required}
          type={inputType}
          value={value || ''}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          {...rest}
        />
      )

    case 'email':
      return (
        <MuiEmailField
          showAdornment={showAdornment}
          id={id}
          enableHelpText={enableHelpText}
          helpText={helpText}
          fullWidth={fullWidth}
          label={label}
          placeholder={placeholder}
          required={required}
          type={inputType}
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur(e.target.value)}
          disabled={disabled}
          forceError={forceError}
        />
      )

    case 'tel':
      return (
        <MuiPhoneNumberField
          showAdornment={showAdornment}
          id={id}
          type={inputType}
          label={label}
          value={value}
          fullWidth={fullWidth}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          forceError={forceError}
          enableHelpText={enableHelpText}
          helpText={helpText}
          onBlur={onBlur}
          onChange={(value) => onChange(value)}
        />
      )

    case 'select':
      return (
        <MuiSelectField
          showAdornment={showAdornment}
          options={options}
          optionMatchValue={optionMatchValue}
          optionMatchProp={optionMatchProp}
          id={id}
          type={inputType}
          label={label}
          value={value}
          fullWidth={fullWidth}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          forceError={forceError}
          enableHelpText={enableHelpText}
          helpText={helpText}
          onBlur={onBlur}
          searchable={searchable}
          //every select in the app currenly uses onchange to detect when to update intake state,
          //so we can just pass the onblur event object incase we ever need it for something!
          onChange={(e) => onChange(e.target.value)}
          {...rest}
        />
      )

    case 'multiselect':
      return (
        <MuiMultiSelect
          showAdornment={showAdornment}
          options={options}
          id={id}
          type={inputType}
          label={label}
          value={value}
          fullWidth={fullWidth}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          forceError={forceError}
          enableHelpText={enableHelpText}
          helpText={helpText}
          onBlur={(e) => onBlur(e.target.value)}
          onChange={(e) => onChange(e.target.value)}
        />
      )

    case 'zipcode':
      return (
        <MuiZipcodeField
          showAdornment={showAdornment}
          id={id}
          disabled={disabled}
          label={label}
          value={value || ''}
          fullWidth={fullWidth}
          enableHelpText={enableHelpText}
          helpText={helpText}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur(e.target.value)}
          required={required}
          forceError={forceError}
        />
      )

    case 'date':
      return (
        <MuiDateField
          id={id}
          label={label}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          enableHelpText={enableHelpText}
          helpText={helpText}
          disabled={disabled}
          {...rest}
        />
      )

    case 'splitdate':
      return (
        <MuiSplitDateField
          id={id}
          label={label}
          value={value}
          onChange={onChange}
          required={required}
          {...rest}
        />
      )

    case 'deduction':
      return <DeductionsStep />
    case 'deductionTypeSelection':
      return <DeductionTypeSelection />
    case 'deductionsReview':
      return <DeductionsStepReview />
    case 'tspLoan':
      return <TspLoansStep />
    case 'tspLoanReview':
      return <TspLoanReview />

    //im leaving this one without full width so i know if ever there is something thats not, its
    // most likely a mismatch in type name or an unbuilt type
    default:
      return (
        <MuiTextField
          showAdornment={showAdornment}
          id={id}
          enableHelpText={enableHelpText}
          helpText={helpText}
          label={label}
          placeholder={placeholder}
          required={required}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur(e.target.value)}
          disabled={disabled}
          {...rest}
        />
      )
  }
}
